import { useState } from 'react';
import { TextField, InputAdornment, IconButton, Box, Typography } from '@mui/material';
import VisibilityIcon    from '@mui/icons-material/VisibilityRounded';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOffRounded';
import CheckCircleIcon   from '@mui/icons-material/CheckCircleRounded';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUncheckedRounded';

const RULES = [
  { key: 'len',   label: 'At least 8 characters',       test: v => v.length >= 8 },
  { key: 'upper', label: 'At least 1 uppercase letter',  test: v => /[A-Z]/.test(v) },
  { key: 'lower', label: 'At least 1 lowercase letter',  test: v => /[a-z]/.test(v) },
  { key: 'digit', label: 'At least 1 number',            test: v => /[0-9]/.test(v) },
];

export function PasswordField({ value, onChange, label = 'Password', required = true, showHints = true }) {
  const [show, setShow] = useState(false);
  const touched = value.length > 0;

  return (
    <Box>
      <TextField
        label={label}
        type={show ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        fullWidth
        required={required}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => setShow(p => !p)} size="small" tabIndex={-1}>
                {show ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      {showHints && (
        <Box sx={{ mt: 1, pl: 0.5, display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
          {RULES.map(rule => {
            const passed = rule.test(value);
            return (
              <Box key={rule.key} display="flex" alignItems="center" gap={0.4}
                sx={{ minWidth: '48%' }}>
                {(touched && passed)
                  ? <CheckCircleIcon sx={{ fontSize: 13, color: '#10b981' }} />
                  : <RadioButtonUncheckedIcon sx={{ fontSize: 13, color: touched ? '#ef4444' : '#cbd5e1' }} />
                }
                <Typography variant="caption"
                  sx={{ color: !touched ? '#94a3b8' : passed ? '#10b981' : '#ef4444', fontSize: '0.72rem' }}>
                  {rule.label}
                </Typography>
              </Box>
            );
          })}
        </Box>
      )}
    </Box>
  );
}
